import { render } from "./z-money.vue?vue&type=template&id=47ff1336"
import script from "./z-money.vue?vue&type=script&lang=js"
export * from "./z-money.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__